'use strict';

var Request = require('./Request');

/**
 *
 * @param url
 * @param container A DOM element or the ID of a DOM element.
 * @param options
 * @constructor
 */
var ImmediateRequest = function(url, container, options) {
    this.initialize(url, container, options);
};

jQuery.extend(jQuery.extend(ImmediateRequest.prototype, Request.prototype), {
    initialize: function(url, container, options) {
        this.requestUrl = url;

        if (typeof container === 'string') {
            this.contentContainer = document.getElementById(container);
        } else {
            this.contentContainer = container;
        }

        this.initializeEventHandlers();

        if(options){
            this.method = options.method || 'post';
            this.completeEvents.events = options.completeEvents || [];
            this.parameters = options.parameters;
        }

        this.getContent();
    }
});

module.exports = ImmediateRequest;


//////////////////
// WEBPACK FOOTER
// ./mits/AjaxAPI/ImmediateRequest.js
// module id = 9
// module chunks = 0